import { TagProps } from '@nimbus-ds/components';
import { RedoIcon, CheckIcon, CloseIcon } from '@nimbus-ds/icons';
import { ProductTransferListResponseDto } from '@tiendanube/common';

export const ICON_SIZE = 12;

export const STATUS_MAP: Record<
  ProductTransferListResponseDto[number]['status'],
  TagProps['appearance']
> = {
  pending: 'primary',
  ready: 'success',
  failed: 'danger',
};

export const ICON_MAP: Record<
  ProductTransferListResponseDto[number]['status'],
  React.ReactNode
> = {
  pending: <RedoIcon size={ICON_SIZE} />,
  ready: <CheckIcon size={ICON_SIZE} />,
  failed: <CloseIcon size={ICON_SIZE} />,
};
